export const MILLISECONDS = 1000
export const MINUTE = 60 * MILLISECONDS
export const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR
export const GAP_TIME = 1000
export const DELAY_TIME = GAP_TIME / 10
